module.exports = __webpack_public_path__ + "assets/img/assistant-module1.834948a4.png";